import { render } from "./thread_tree.vue?vue&type=template&id=061df1d9"
import script from "./thread_tree.js?vue&type=script&lang=js"
export * from "./thread_tree.js?vue&type=script&lang=js"

import "./thread_tree.vue?vue&type=style&index=0&id=061df1d9&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__